/**
 * Parse a value into a number or undefined
 * @param {*} value
 * @returns {number|undefined}
 */
export const parseNumber = (value) => {
  if (value === '' || value === null || value === undefined) return undefined;
  const number = Number(value);
  return Number.isFinite(number) ? number : undefined;
};
